const pageNames = [
  {
    key: "personal",
    value: "basic_details",
  },
  {
    key: "lender",
    value: "additional_lenders",
  },
  {
    key: "idupload",
    value: "identification_image",
  },
  {
    key: "agreementupload",
    value: "agreement_upload",
  }
];

export const getPageName = (key) => {
  return pageNames.find((page) => page.key === key)?.value;
};
